import { ActionTree } from 'vuex';
import { FilterGroup1, FilterGroup2 } from 'ctp-filter-group-management';
import {
  FETCH_FILTER_GROUPS,
  CREATE_FILTER_GROUP,
  DELETE_FILTER_GROUP,
  SET_ERROR,
  GroupManagementState,
  UPDATE_GROUPS_STATE,
  UPDATE_NAVIGATION,
  REINIT,
  FILTER_GROUP_NAVIGATION,
  USER_SELECTION_REGISTER_GROUP,
  USER_SELECTION_CLEAR_GROUPS,
  USER_SELECTION_RESET_ACTIONS,
  TRIGGER_GROUP_USER_SELECTION_ACTION,
  FETCH_TOTAL_GROUPS,
  EDIT_FILTER_GROUP
} from './types';
import { GroupManagementApiCaller as GroupManagementApi } from './callers';

const actions: ActionTree<GroupManagementState, Record<string, never>> = {
  [REINIT]({ commit }): void {
    commit(REINIT);
  },
  [UPDATE_NAVIGATION]({ commit }, payload): void {
    commit(UPDATE_NAVIGATION, payload);
  },
  [FILTER_GROUP_NAVIGATION]({ commit }, payload): void {
    commit(FILTER_GROUP_NAVIGATION, payload);
  },
  [USER_SELECTION_REGISTER_GROUP]({ commit }, payload): void {
    commit(USER_SELECTION_REGISTER_GROUP, payload);
  },
  [USER_SELECTION_CLEAR_GROUPS]({ commit }): void {
    commit(USER_SELECTION_CLEAR_GROUPS);
  },
  [USER_SELECTION_RESET_ACTIONS]({ commit }): void {
    commit(USER_SELECTION_RESET_ACTIONS);
  },
  [TRIGGER_GROUP_USER_SELECTION_ACTION]({ commit }, payload): void {
    commit(TRIGGER_GROUP_USER_SELECTION_ACTION, payload);
  },
  async [FETCH_FILTER_GROUPS]({ commit, rootGetters }): Promise<void> {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    commit(UPDATE_GROUPS_STATE, {
      view: 'groups',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_GROUPS_STATE, {
      view: 'groups',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_GROUPS_STATE, {
      view: 'groups',
      stateKey: 'error',
      stateValue: false
    });
    return GroupManagementApi.listFilterGroups(20, 0, master.id)
      .then((res) => {
        commit(FETCH_FILTER_GROUPS, res);
        commit(UPDATE_GROUPS_STATE, {
          view: 'groups',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'groups',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'groups',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_GROUPS_STATE, {
          view: 'groups',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'groups',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'groups',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  async [CREATE_FILTER_GROUP]({ commit, rootGetters }, payload): Promise<{ notificationStatus: string, code: number }> {
    const master = rootGetters['user/getSelectedMasterAccount'];
    const filterGroup: FilterGroup1 = {
      name: payload.filterGroup.name,
      filters: payload.filterGroup.filters,
      masterId: master.id
    };
    return GroupManagementApi.createFilterGroup(filterGroup)
      .then(() => ({
        notificationStatus: 'success', code: 200
      }))
      .catch((res) => {
        commit(SET_ERROR, res.message);
        return ({
          notificationStatus: 'error', code: res.status
        });
      });
  },
  async [EDIT_FILTER_GROUP]({ commit }, payload): Promise<{ notificationStatus: string, code: number }> {
    const filterGroup: FilterGroup2 = {
      name: payload.filterGroup.name,
      filters: payload.filterGroup.filters
    };
    return GroupManagementApi.editFilterGroup(payload.filterGroup.id, filterGroup)
      .then(() => ({
        notificationStatus: 'success', code: 200
      }))
      .catch((res) => {
        commit(SET_ERROR, res.message);
        return ({
          notificationStatus: 'error', code: res.status
        });
      });
  },
  async [DELETE_FILTER_GROUP]({ commit }, payload): Promise<{ notificationStatus: string, code: number }> {
    return GroupManagementApi.deleteFilterGroup(payload)
      .then(() => ({
        notificationStatus: 'success', code: 200
      }))
      .catch((res) => {
        commit(SET_ERROR, res.message);
        return ({
          notificationStatus: 'error', code: res.status
        });
      });
  },
  [SET_ERROR]({ commit }, payload): void {
    commit(SET_ERROR, payload);
  },
  async [FETCH_TOTAL_GROUPS]({ commit, rootGetters }): Promise<void> {
    const master = rootGetters['user/getSelectedMasterAccount'];
    commit(UPDATE_GROUPS_STATE, {
      view: 'total',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_GROUPS_STATE, {
      view: 'total',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_GROUPS_STATE, {
      view: 'total',
      stateKey: 'error',
      stateValue: false
    });
    return GroupManagementApi.countFilterGroups(master.id)
      .then((res) => {
        commit(FETCH_TOTAL_GROUPS, res);
        commit(UPDATE_GROUPS_STATE, {
          view: 'total',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'total',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'total',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_GROUPS_STATE, {
          view: 'total',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'total',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_GROUPS_STATE, {
          view: 'total',
          stateKey: 'error',
          stateValue: true
        });
      });
  }
};
export default actions;
